export const iconsArr = [
  { img: "./icons/html-icon.png", title: "HTML" },
  { img: "./icons/css-icon.png", title: "CSS" },
  { img: "./icons/javascript-icon.png", title: "JavaScript" },
  { img: "./icons/react-icon.webp", title: "React" },
  { img: "./icons/redux-icon.webp", title: "Redux" },
  { img: "./icons/nodejs-icon.png", title: "" },
  { img: "./icons/Expressjs-icon.png", title: "" },
  { img: "./icons/sql-icon.png", title: "" },
  { img: "./icons/git-icon.png", title: "" },
  { img: "./icons/github-icon.png", title: "GitHub" },
  { img: "./icons/html-icon.png", title: "HTML" },
  { img: "./icons/css-icon.png", title: "CSS" },
  { img: "./icons/javascript-icon.png", title: "JavaScript" },
  { img: "./icons/react-icon.webp", title: "React" },
  { img: "./icons/redux-icon.webp", title: "Redux" },
  { img: "./icons/nodejs-icon.png", title: "" },
  { img: "./icons/Expressjs-icon.png", title: "" },
  { img: "./icons/sql-icon.png", title: "" },
  { img: "./icons/git-icon.png", title: "" },
  { img: "./icons/github-icon.png", title: "GitHub" },
  { img: "./icons/html-icon.png", title: "HTML" },
  { img: "./icons/css-icon.png", title: "CSS" },
  { img: "./icons/javascript-icon.png", title: "JavaScript" },
  { img: "./icons/react-icon.webp", title: "React" },
  { img: "./icons/redux-icon.webp", title: "Redux" },
  { img: "./icons/nodejs-icon.png", title: "" },
  { img: "./icons/Expressjs-icon.png", title: "" },
  { img: "./icons/sql-icon.png", title: "" },
  { img: "./icons/git-icon.png", title: "" },
  { img: "./icons/github-icon.png", title: "GitHub" },
  { img: "./icons/html-icon.png", title: "HTML" },
  { img: "./icons/css-icon.png", title: "CSS" },
  { img: "./icons/javascript-icon.png", title: "JavaScript" },
  { img: "./icons/react-icon.webp", title: "React" },
  { img: "./icons/redux-icon.webp", title: "Redux" },
  { img: "./icons/nodejs-icon.png", title: "" },
  { img: "./icons/Expressjs-icon.png", title: "" },
  { img: "./icons/sql-icon.png", title: "" },
  { img: "./icons/git-icon.png", title: "" },
  { img: "./icons/github-icon.png", title: "GitHub" },
];
